import {default as cx} from "classnames"

export const RatingRow = ({num = -1, stmt, rating, maxRating}) => {
    return (
        <div className="d-flex flex-row align-items-center fs-5 gap-2">
            {num !== -1 && (
                <div className="d-flex flex-column">
                    <div className="symbol symbol-30px me-2">
                        <div className="symbol-label fs-5 fw-semibold bg-primary text-inverse-danger">{num}</div>
                    </div>
                </div>
            )}
            <div className="flex-grow-1 fw-bold">{stmt}</div>
            <div className="rating">
                {Array.from({length: maxRating}, (_, i) => (
                    <div key={i} className={cx("rating-label me-1", {checked: rating >= i + 1})}>
                        <i className="fas fa-square fs-3"></i>
                    </div>
                ))}
                <div className="ms-1 fw-bold fs-4">{rating}</div>
            </div>
        </div>
    )
}

export default RatingRow
